export const LOCAL_PREVIEW = process.env.NODE_ENV === 'development'
  && process.env.REACT_APP_LOCAL_PREVIEW === 'true'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);

// Fail closed if a new feature accidentally uses a remote API in local mode.
export function installLocalRequestGuard() {
  if (!LOCAL_PREVIEW) return;
  document.body.style.paddingBottom = '90px';
  document.body.style.setProperty('--local-preview-bottom', '90px');
  const original = window.fetch.bind(window);
  window.fetch = (input, options) => {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, window.location.origin);
    if (!['localhost', '127.0.0.1'].includes(url.hostname)) {
      return Promise.reject(new Error('The local preview blocked a remote API request.'));
    }
    return original(input, { ...options, redirect: 'error' });
  };
}
